export default __webpack_public_path__ + "static/media/moreInfo.656e0c92.svg";